// Generated by purs version 0.14.4
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var T2 = (function () {
    function T2(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    T2.create = function (value0) {
        return function (value1) {
            return new T2(value0, value1);
        };
    };
    return T2;
})();
var toTuple = function (v) {
    return new Data_Tuple.Tuple(v.value0, v.value1);
};
var proj2 = function (v) {
    return v.value1;
};
var proj1 = function (v) {
    return v.value0;
};
var genericT2 = {
    to: function (x) {
        return new T2(x.value0, x.value1);
    },
    from: function (x) {
        return new Data_Generic_Rep.Product(x.value0, x.value1);
    }
};
var showT2 = function (dictShow) {
    return function (dictShow1) {
        return {
            show: Data_Show_Generic.genericShow(genericT2)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsProduct(Data_Show_Generic.genericShowArgsArgument(dictShow))(Data_Show_Generic.genericShowArgsArgument(dictShow1)))({
                reflectSymbol: function () {
                    return "T2";
                }
            }))
        };
    };
};
var udecodeT2 = function (dictDecode) {
    return function (dictDecode1) {
        return {
            unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericT2)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsManyArgs(Unscramble_Generic.genericDecodeManyArgsProduct(Unscramble_Generic.genericDecodeManyArgsArgument(dictDecode))(Unscramble_Generic.genericDecodeManyArgsArgument(dictDecode1)))))(Unscramble_Generic.defaultOptions)
        };
    };
};
var fromTuple = function (v) {
    return new T2(v.value0, v.value1);
};
var eqT2 = function (dictEq) {
    return function (dictEq1) {
        return {
            eq: function (x) {
                return function (y) {
                    return Data_Eq.eq(dictEq)(x.value0)(y.value0) && Data_Eq.eq(dictEq1)(x.value1)(y.value1);
                };
            }
        };
    };
};
var encodeT2 = function (dictEncode) {
    return function (dictEncode1) {
        return {
            encode: Foreign_Encoding.defaultEncode(genericT2)(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "T2";
                }
            })(Foreign_Generic_Class.genericEncodeArgsProduct(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode)))(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode1)))))
        };
    };
};
var decodeT2 = function (dictDecode) {
    return function (dictDecode1) {
        return {
            decode: Foreign_Encoding.defaultDecode(genericT2)(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "T2";
                }
            })(Foreign_Generic_Class.genericDecodeArgsProduct(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode)))(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(dictDecode1))))(Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))
        };
    };
};
export {
    T2,
    toTuple,
    fromTuple,
    proj1,
    proj2,
    genericT2,
    eqT2,
    showT2,
    decodeT2,
    udecodeT2,
    encodeT2
};
//# sourceMappingURL=index.js.map
